export const GALLERY = [
  { 
    imgDetail : [ 
                  { id: 1, img: "../img/gallery/Parliament-1.jpg", caption: "Rt. Hon’ble Speaker of the House of Commons Sir Lindsay Hoyle receiving KIOCH Token of Love from KIOCH Chairman Prof. Bhagawan Koirala" },
                  { id: 2, img: "../img/gallery/Parliament-2.jpg", caption: "Sir Lindsay Hoyle with Prof Koirala and Health Exchange Nepal chairman Mr Jeremy Ward and Prof Satyan M Rajbhandari" },
                  { id: 3, img: "../img/gallery/Parliament-3.jpg", caption: "" },
                  { id: 4, img: "../img/gallery/Parliament-4.jpg", caption: "Sir Lindsay Hoyle addressing about the child care in Nepal and appreciating KIOCH for promoting child health in Nepal" },
                  { id: 5, img: "../img/gallery/Parliament-5.jpg", caption: "UK Friends of KIOCH fund raising charity dinner on 8 July 2023 for introduction of KIOCH to UK Nepalese Community at Empire Hall, Aldershot" },
                  { id: 6, img: "../img/gallery/Parliament-6.png", caption: "A heart touching mini drama on deteriorating child performed at the charity fund raising dinner" },
                  { id: 7, img: "../img/gallery/Parliament-7.jpg", caption: "Tamu Dhee UK donation" },
                  { id: 8, img: "../img/gallery/Parliament-8.png", caption: "" },
                ],
    description: "KIOCH was introduced to the UK on 4th July 2023 at Speakers state room in the Parliament House",
    galleryId: 1
  },
];

export const HOME_ARTICLES = [
  {
    id: 1,
    catagory: "Jumbotron",
    data: [{header: "We Are K-Pals UK", description: "We support Kathmandu Institute of Child Health (KIOCH) to provide affordable and accessible child health care in Nepal."},
           {header: "CHARITABLE OBJECTIVES", description: "The main objectives of KPALS UK are to relieve sickness and promote the health of sick children in Nepal by providing or assisting in the provision of equipment, facilities, and training that complement the services provided by doctors."}]
  },
  {
    id: 2,
    catagory: "What We Do",
    data: {header: "What We Do", description: "KIOCH was introduced to the UK on July 4, 2023, at the Speakers’ State Room in Parliament House. K-PALS UK is a newly established charity in the UK dedicated to supporting the Kathmandu Institute of Child Health (KIOCH). Founded in 2017, KIOCH is a non-profit organization committed to providing affordable and accessible child healthcare in Nepal."}
  },
  {
    id:3,
    catagory: "More About KIOCH - Nepal",
    data: {header: "More About KIOCH - Nepal", description: "KIOCH [Kathmandu Institute of Child Health] is a not-for-profit organization established in 2017. It aims to deliver integrated multispecialty high-quality child healthcare that is affordable, accessible, and available to all, thus advancing Quality of Life of Children in Nepal. KIOCH focuses on providing solutions to ever rising healthcare needs and consistent poor health outcomes for millions of children in Nepal. It believes on timely adaptation of scientific medical advances, technologies and valued people-centered care that are of international standards."}
  }
]

export const NEWS = [
    {
    id: 1,
    title: <>K-PALS UK Charity Evening 2026</>,
    location: "Blue Room, Harrow",
    date: "18 April 2026",
    description:
      [
        <>K-PALS UK charity event has been successfully completed in support of Kathmandu Institute of Child Health (KIOCH), which included cultural performances, a raffle draw, book sale (signed copies of auto biography of Dr Bhagawan Koirala- HRIDAYA) and an auction.</>,
        <>The event started with introduction of K-PALS UK trustees.</>,
        <>Welcoming all the participants, K-PALS UK Trustee Dr. Durga Sigdel informed that K-PALS UK, registered as a charity in the UK, is working to provide financial and medical equipment as well as training and skills transfer to doctors, nurses and other human resources in KIOCH, Nepal.</>,
        <>Addressing the event virtually from Kathmandu, Dr. Bhagwan Koirala (Chairman, KIOCH) presented the slides and said that the Kathmandu Institute of Child Health, established as a non-profit organization in 2017, aims to provide high-quality health services to children across Nepal. He said that despite significant improvements in maternal and infant mortality rates in the last three decades, the child mortality rate in Nepal is still high compared to developed countries. He said that the aim is to build children's hospitals in all seven provinces of Nepal with the aim of improving the living standards of children by providing not only quality, but also affordable and accessible health services. He said that a children's hospital has been operating in Damak in Koshi Province for the past three years and a central hospital ( Kathmandu Children’s Hospital ) is partially completed at Hepali Heights, Budhanilkantha Municipality, Kathmandu, which has started to function for past 4 months.  He also expressed his heartfelt gratitude to all the organizations including Nepali friends, living abroad who are helping to build the hospital.</>,
        <>The chief guest of the program, Nepal's acting ambassador to the UK, Mr Bipin Duwadi, said that the government of Nepal is implementing many investments and programs for improving child health, and said that the efforts of organizations like Kathmandu Institute of Child Health to provide quality health services to children in different parts of the country are commendable. He also thanked Nepalis living in the UK and around the world who have been helping to improve services like education and health in Nepal.</>,
        <>Dr. Sudarshan Gurung (Advisor K-PALS UK) sang popular songs during the program, while artists Dr. Pratishtha Tripathi, Kabita Rana Magar, Deepti Khoju, Arisha Shakya, and Aisha Moktan performed dances.</>,
        <>Speaking at the event, record-breaking mountaineer Mr Hari Budhamagar said that about 1.3 billion people in the world currently have some kind of disability, and he has successfully climbed the highest peaks of all seven continents, including the highest peak, Mount Everest, to show that disabled people can also fulfill their dreams. He said that everyone should join hands to help the children of Nepal. Dr. David Stonehouse, advisor to K-PALS UK, said that they are helping to develop the skills of Nurses associated with KIOCH.</>,
        <>NRNA ICC Vice President Mr Ram Sharan Simkhada stressed that transparency would help in raising funds and stressed that the collected funds should be utilized properly. Similarly, NRNA UK President Mr Rajendra Pudasaini said that charities are doing what the government should do and pledged to provide all possible support, both personally and institutionally, to the campaign to build children's hospitals across Nepal. He said that today's children are the leaders of the future and expressed the view that if they are provided with good education and health services, they will become the pillars of the country.</>,
        <>K-PALS UK trustee, Mr Shivaji Shrestha, gave a vote of thanks to all participants, including the sponsors (A-Star Financial Solutions UK, Buddha Mortgage, RK CO Health Limited). There were more than 150 participants (including members of NRNA UK, NDAUK, NNAUK, Tamu Dhee UK, CAT-UK, NAA UK) in the charity event.</>,
        <>Miss Prasuna Kadel, Trustee of K-Pals UK conducted the programme.</>,
        <>K-PALS UK Trustees Prof. Dr. Satyan Rajbhandari and Dr. Ramesh Khoju played an active role in organizing the programme. </>,
        <><div class="ratio ratio-16x9">
            <iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fpermalink.php%3Fstory_fbid%3Dpfbid02FTxYMfb7KbJA6EcT1c9bpBYvF9ccEWuL249Lykqz4qdEDj2DWu8eLY4GSeRhs9Qml%26id%3D61564965185525&show_text=true&width=500" frameborder="0" allowfullscreen title="K-PALS UK Charity Evening 2026"></iframe>
            {/* <iframe src="https://www.youtube.com/embed/gijMm5COtRI" frameborder="0" allowfullscreen title="K-PALS UK Event Video"></iframe> */}
        </div></>,
      ],
      img: [
        "../img/news/18-apr-2026-1.jpg",        
        "../img/news/18-apr-2026-2.jpg"             
      ],
  },
  {
    id: 2,
    title: <>Prof Satyan Rajbhandari Meets The Team </>,
    location: "KIOCH-Kathmandu",
    date: "2 September 2025",
    description:
      [
        <>K-PALS UK trustee Prof Satyan Rajbhandari meets the team of paediatricians at KIOCH-Kathmandu.</>,
        <>K-PALS UK is eager to support the team to get UK experience in NHS hospitals which would help to provide an excellent multidisciplinary service and healthcare to children in Nepal. </>,
      ],
      img: [
        "../img/news/2-sep-2025-1.jpg",        
        "../img/news/2-sep-2025-2.jpg"             
      ],
  },
  {
    id: 3,
    title: <>K-PALS UK at Nepali Mela 2025</>,
    location: "Kempton Race Course, London",
    date: "26 August 2025",
    description:
      [
        <>K-PALS UK was present (with a stall) at Nepali Mela 2025, organised by Tamu Dhee UK on 26<sup>th</sup> of August 2025 in Kempton Race Course, London.</>,
        <>There were more than 13,000 Nepalese residing in the UK, participated in the Mela. K-PALS UK had an opportunity to promote its objectives and activities (to support Kathmandu Institute of Child Health) to thousands of Nepalese and made the networking.</>,
        <>The stall was graciously visited by the Nepalese ambassador to the UK his Excellency Mr Chandra K Ghimire and Mr Kul Man Ghising, escorted by Tamu Dhee UK President Mr Jum Kaji Gurung.</>,
        <>Miss Dipti Shrestha and Miss Aarisha Shakya- pupils from Bohunt School Worthing and Master Vihaan Newar- a pupil from Penglais School, Aberystwyth volunteered in the stall.</>,
        <>K-PALS UK Trustee Dr Ramesh Khoju had an opportunity to give a <a href="https://www.instagram.com/reel/DNvRyTX0FrP/?igsh=MWpvdjgwNnpxamgxcQ%3D%3D" target="_blank" rel="noopener noreferrer" style={{color:"darkblue", textDecoration:"underline",fontWeight:"bold"}}> short interview </a> to  Nepalese Business Directory - an online platform designed to help Nepalese businesses in the UK connect with their ideal customers.</> 
      ],
      img: [
        "../img/news/26-Aug-2025-6.jpg",        
        "../img/news/26-Aug-2025-2.jpg",
        "../img/news/26-Aug-2025-3.jpg",
        "../img/news/26-Aug-2025-4.jpg",      
      ],
  },
  {
    id: 4,
    title: <>K-PALS UK at Nepalese Doctors Association UK 40<sup>th</sup> Annual Conference</>,
    location: "Durham, UK",
    date: "27 July 2025",
    description:
      [
        <>K-PALS UK trustee Prof Satyan Rajbhanadari delivered a presentation on K-PALS at Nepalese Doctors Association UK (an official partner of KIOCH), 40 th Annual Conference, Durham.</>, 
        <>Prof Rajbahndari briefly highlighted about the Kathmandu Institute of Child Health, including 
        progress of KIOCH- Kathmandu hospital building construction, and activities in KIOCH-Damak (since hospital started its service in May 2023). KIOCH was introduced in the UK by Health Exchange
        Nepal (UK registered charity) at speaker’s state room in the House of Parliament in July 2023, followed by charity event to support KIOCH among Nepalese community. This led to
        establishment of K-PALS UK and registered in charity commission in August 2024. He informed K-PALS UK activities, like supporting KIOCH paediatrician for clinical attachment and requested
        NDAUK members to support K-PALS UK by fund raising by just giving page <a href="https://justgiving.com/kpals" target="_blank" rel="noopener noreferrer" style={{color:"darkblue", textDecoration:"underline",fontWeight:"bold"}}> (K-PALS UK - JustGiving)</a>. NDAUK donated £5,000 to KIOCH in 2023 following signing of MOU.</>
      ],
      img: [
        "../img/news/27-July-2025.jpg",      
      ],
  },
  {
    id: 5,
    title: "Visit to KIOCH - Kathmandu Construction Site",
    location: "KIOCH-Kathmandu",
    date: "16 July 2025",
    description:
      [
        <>K-PALS UK trustee Mr Shibaji Shrestha recently visited KIOCH -Kathmandu construction site. He even became a witness of progress and handover of equipments from Shenzhen 
        Mindray Bio Medical (Chinese and Nepalese) team. Emergency and OT services are going to start soon (within 2 months) in South West building.
        </>
      ],
      img: [
        "../img/news/16-July-2025-1.JPG",
        "../img/news/16-July-2025-2.JPG",
        "../img/news/16-July-2025-3.JPG",        
      ],
  },
  {
    id: 6,
    title: "Clinical Observation in Paediatric Neurology",
    location: "Havering and Redbridge University Hospital NHS Trust, Romford",
    date: "17 May 2025",
    description:
      [
        <> K-PALS UK welcomes Dr Prabhu Agrawal (KIOCH- Damak ) who arrived London on 17th of May 2025. </>,
        <> K-PALS UK is pleased to support
        <a href="https://kpalsuk.org/documents/letter-of-gratitude-from-Dr-Agrawal.pdf" target="_blank" rel="noopener noreferrer" style={{color:"darkblue", textDecoration:"underline",fontWeight:"bold"}}> Dr Agrawal </a>        
          for his clinical observership in Paediatric Neurology under the supervision of K-PALS UK trustee Dr Durga Sigdel, at Havering and Redbridge University Hospital NHS Trust, Romford for next 8 weeks.</> ,        
      ],
    img: [
      "../img/news/Clinical-Observation-in-Paediatric-Neurology.JPG"
    ]
  },
  {
    id: 7,
    title: "Basingstoke Half Marathon - A Fund Raising Program",
    location: "Basingstoke, UK",
    date: "06 October 2024",
    description:
      [
        "K-PALS UK trustee Mr Shibaji Shrestha has completed Basingstoke Half Marathon (21 km) in 1 hour 44 minutes and 55 seconds for raising fund for caring sick children in Nepal. K-PALS UK is very grateful to Mr Shrestha who has been successful in raising more than £1200 and also would like to thank all well wishers for their kind contributions."
      ],
    img: [
      "../img/news/Shibaji-Marathon1-6-oct-2024.jpg",
      "../img/news/Shibaji-Marathon2-6-oct-2024.jpg",
    ],
  },
  {
    id: 8,
    title: "Meeting with Founder Chairman of KIOCH",
    location: "KIOCH-Kathmandu",
    date: "27 September 2024",
    description:
      [
        "K-PALS UK trustee Prof Satyan Rajbhandari with Dr Barry Pfizer ( Medical lead- So the Child May Live: So the Child May Live – Saving children’s lives in Nepal ) had a very fruitful meeting in Kathmandu with Founder Chairman of KIOCH, Prof Bhagawan Koirala, regarding future collaboration in caring sick children in Nepal."
      ],
    img: ["../img/news/KIOCH-meeting-27-sep-2024.jpg"],
  },
  {
    id: 9,
    title: "Meeting with colleagues at KIOCH-Damak",
    location: "KIOCH-Damak",
    date: "01 July 2024",
    description:
      [
        "Dr Durga Sigdel, Consultant Paediatrician, K-PALS UK team member visited KIOCH- Damak. \n Dr Sigdel was delighted to meet colleagues at KIOCH-Damak. \n He expressed : \n “The hospital is managed very well. All staff are working very hard to provide great care.”"
      ],
    img: ["../img/news/Durga-at-KIOCH-Damak-01-jul-2024.jpg"],
  },
  {
    id: 10,
    title: "Visit to KIOCH - Kathmandu",
    location: "KIOCH-Kathmandu",
    date: "01 Ocotber 2023",
    description:
      [
        "Miss Prasuna Kadel , K-PALS UK team member visited KIOCH – Kathmandu. \n She said It was an honour meeting Prof Bhagawan Koirala, chairman KIOCH and to witness the rapid construction progress of KIOCH Kathmandu, a multi-specialty care center. \n Specialties chosen both based on the population needs and financial viability. KIOCH promises to provide multi-speciality services: Cardiology & Cardiothoracic surgery, Oncology, Mental Health, Emergency services for children, Critical care, Orthopedics & Trauma services We recommend buying your favorite toothbrush at super low prices with free shipping, and you can also pick up your order at the store on the same day."
      ],
    img: ["../img/news/october-2023.jpg"],
  },
  {
    id: 11,
    title: "Visit to KIOCH headquarer at Hepali Height",
    location: "KIOCH-Kathmandu",
    date: "01 September 2023",
    description:
      [
        "K-PALS UK team members Prof Satayn Rajbhandari and Dr Ramesh Khoju visited KIOCH headquarter at Hepali Height. An infant training manikin was donated for KIOCH- Damak."
      ],
    img: [
      "../img/news/sep-2023-1.jpg",
      "../img/news/sep-2023-2.jpg",
      "../img/news/sep-2023-3.jpg",
      "../img/news/sep-2023-4.jpg",
    ],
  },
];

export const ADVISORY_BOARD = [
  {
    id: 1,
    img: "../img/advisory-board/DrAnilTuladhar.jpg",
    name: "Dr Anil Tuladhar",
    position: "Consultant Paediatrician, Middlesbrough, UK",
    specialInterest: ["Paediatric Respiratory Medicine",],
  },
  {
    id: 2,
    img: "../img/advisory-board/DrJamunaAcharya.jpg",
    name: "Dr Jamuna Acharya",
    position: "Consultant Community Paediatrician, Liverpool, UK",
    specialInterest: ["Child Protection",],
  },
  {
    id: 3,
    img: "../img/advisory-board/DrKausikKhan.jpg",
    name: "Dr Kausik Khan",
    position: "Consultant Paediatrician, Aberystwyth, Wales, UK",
    specialInterest: ["Allergy",],
  },
  {
    id: 4,
    img: "../img/advisory-board/DrSiriGautam-2.jpg",
    name: "Dr Siri Gautam",
    position: "Consultant in Paediatric Emergency Medicine, Sunderland, UK",
    specialInterest: [],
  },
  {
    id: 5,
    img: "../img/advisory-board/DrSudarshanGurung.jpg",
    name: " Dr Sudarshan Gurung",
    position:
      "Consultant Haematologist, Clinical Lead Haematology, Medway Maritime Hospital NHS trust",
    specialInterest: [],
  },
  {
    id: 6,
    img: "../img/advisory-board/SoniaBasson-1.jpg",
    name: " Miss Sonia Basson",
    position:
      "Consultant Specialist Neonatal and Paediatric Surgeon at Great Ormond Street Hospital.",
    specialInterest: ["Colorectal Surgery", "Neonatal Surgery", "Vascular Malformations", "Medical Education", "Global Health"],
  },
    {
    id: 7,
    img: "../img/advisory-board/DrSaradaGurung.jpg",
    name: " Dr Sarada Gurung",
    position:
      "Consultant in Paediatric Anaesthesia at Great Ormond Street Hospital for Children.",
    specialInterest: [],
  },
  {
    id: 8,
    img: "../img/advisory-board/DrDavidPeter.png",
    name: " Dr David Peter Stonehouse",
    position:
      "Senior Lecturer – School of Health, Leeds Beckett University",
    specialInterest: ["Nursing Education & Training"],
  },
    {
    id: 9,
    img: "../img/advisory-board/PrajwalGhimire.jpeg",
    name: " Mr Prajwal Ghimire",
    position:
      <>MBBS MRCSEd. MSc. PhD, Kings College Hospital, London </>,      
    specialInterest: ["Neurosurgeon-scientist - 15 years of medical experience actively involved in clinical and academic research focused on neurosurgery, neuro-oncology, cancer imaging, digital health and artificial intelligence", "4 years of dedicated academic research experience, his work focuses on the intersection of cancer neuroimaging and radiogenomics", "Editorial roles for Nature Scientific Reports and Frontiers of Surgery (Neurosurgery Section) Journal"],
  },
];

export const TEAM = [
  {
    id: 1,
    img: "../img/team/DrRameshKhojuShrestha.png",
    name: "Dr Ramesh Khoju Shrestha",
    position: "Consultant Anaesthetist",
  },
  {
    id: 2,
    img: "../img/team/ProfSatyanManRajbhandari.jpg",
    name: "Prof Satyan Man Rajbhandari",
    position: "Consultant Diabetologist",
  },
  {
    id: 3,
    img: "../img/team/DrDurgaSigdel.jpg",
    name: "Dr Durga Sigdel",
    position: "Consultant Paediatrician",
  },
  {
    id: 4,
    img: "../img/team/MissPrasunaKandel.jpg",
    name: "Miss Prasuna Kandel",
    position: "Advanced Nurse Practitioner in Critical care",
  },
  {
    id: 5,
    img: "../img/team/MrShivajiShrestha.jpg",
    name: "Mr Shibaji Shrestha",
    position: "Social Worker",
  },
];
